/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-19 13:53:42
 */
/**
 * 测量点
 */
const measure = {
  addMeasureTemplateGroup: "/api/addMeasureTemplateGroup", //添加模板组
  modifyMeasureTemplateGroup: "/api/modifyMeasureTemplateGroup", //修改模板组
  deleteMeasureTemplateGroup: "/api/deleteMeasureTemplateGroup", //删除模板组
  getMeasureTemplateGroups: "/api/getMeasureTemplateGroups", //查询模板组
  addMeasureTemplate: "/api/addMeasureTemplate", //新增模板
  modifyMeasureTemplate: "/api/modifyMeasureTemplate", //修改模板
  getMeasureTemplates: "/api/getMeasureTemplates", //查询模板
  getMeasureTemplates2: "/api/getMeasureTemplates2", //查询模板
  deleteMeasureTemplate: "/api/deleteMeasureTemplate", //删除参数模板
  addMeasurePropertyTemplateGroup: "/api/addMeasurePropertyTemplateGroup", //添加参数模板组
  modifyMeasurePropertyTemplateGroup: "/api/modifyMeasurePropertyTemplateGroup", //修改参数模板组
  deleteMeasurePropertyTemplateGroup: "/api/deleteMeasurePropertyTemplateGroup", //删除参数模板组
  getMeasurePropertyTemplateGroups: "/api/getMeasurePropertyTemplateGroups", //查询参数模板组
  addMeasurePropertyTemplateItem: "/api/addMeasurePropertyTemplateItem", //新增属性模板参数项
  modifyMeasurePropertyTemplateItem: "/api/modifyMeasurePropertyTemplateItem", //修改属性模板项
  getMeasurePropertyTemplateItems: "/api/getMeasurePropertyTemplateItems", //查询属性模板项
  getMeasurePropertyTemplateItems2: "/api/getMeasurePropertyTemplateItems2", //查询属性模板项
  deleteMeasurePropertyTemplateItem: "/api/deleteMeasurePropertyTemplateItem", //删除属性模板项
  addMeasureExpressionTemplateGroup: "/api/addMeasureExpressionTemplateGroup", //添加计算公式模板组
  modifyMeasureExpressionTemplateGroup:
    "/api/modifyMeasureExpressionTemplateGroup", //修改计算公式模板组
  deleteMeasureExpressionTemplateGroup:
    "/api/deleteMeasureExpressionTemplateGroup", //删除计算公式模板组
  getMeasureExpressionTemplateGroups: "/api/getMeasureExpressionTemplateGroups", //查询计算公式模板组
  addMeasureExpressionTemplateItem: "/api/addMeasureExpressionTemplateItem", //增加测量点模板计量点公式
  modifyMeasureExpressionTemplateItem:
    "/api/modifyMeasureExpressionTemplateItem", //修改测量点模板计量点公式
  deleteMeasureExpressionTemplateItem:
    "/api/deleteMeasureExpressionTemplateItem", //删除测量点模板计量点公式
  getMeasureExpressionTemplateItems: "/api/getMeasureExpressionTemplateItems", //查询测量点模板计量点公式
  getMeasureExpressionTemplateItems2: "/api/getMeasureExpressionTemplateItems2", //查询测量点模板计量点公式
  addContainerOfMeasureTemplate: "/api/addContainerOfMeasureTemplate", //增加测量点模板容器
  modifyContainerOfMeasureTemplate: "/api/modifyContainerOfMeasureTemplate", //修改测量点模板容器
  deleteContainerOfMeasureTemplate: "/api/deleteContainerOfMeasureTemplate", //删除测量点模板容器
  getContainerOfMeasureTemplate: "/api/getContainerOfMeasureTemplate", //查询测量点模板容器
  setEventCodeRestrictionOfMeasureTemplate:
    "/api/setEventCodeRestrictionOfMeasureTemplate", //设置模板告警编码约束
  getEventCodeRestrictionOfMeasureTemplate:
    "/api/getEventCodeRestrictionOfMeasureTemplate", //获取模板告警编码约束
  generateMeasureId: "/api/generateMeasureId", //生成测量点id
  createMeasure: "/api/createMeasure", //创建
  modifyMeasure: "/api/modifyMeasure", //修改
  getMeasuresInfo: "/api/getMeasuresInfo", //查询
  deleteMeasure: "/api/deleteMeasure", //删除
  getMeasuresProperties: "/api/getMeasuresProperties", //查询
  getMeasuresProperties2: "/api/getMeasuresProperties2", //查询
  getMeasureProperty: "/api/getMeasureProperty", //查询
  setMeasureProperties: "/api/setMeasureProperties", //设置测量点属性
  modifyMeasureProperty: "/api/modifyMeasureProperty", //修改测量点属性
  getMeasureEventCodeRestriction: "/api/getMeasureEventCodeRestriction", //获取告警编码约束
  addItemsToMeasureContainer: "/api/addItemsToMeasureContainer", //添加测量点至容器
  getDirectSubNode: "/api/getDirectSubNode", //从容器内查询测量点
  deleteItemsFromMeasureContainer: "/api/deleteItemsFromMeasureContainer", //从容器内删除测量点
  getMeasuresCurrentState: "/api/getMeasuresCurrentState", //查询
  changeMeasureState: "/api/changeMeasureState", //变更状态
  listMeasureStateChangingHistory: "/api/listMeasureStateChangingHistory", //查询状态历史记录
  getMeasuresExpressions: "/api/getMeasuresExpressions", //查询
  modifyMeasuringExpression: "/api/modifyMeasuringExpression", //修改计算公式
  addMeasuringExpression: "/api/addMeasuringExpression", //添加计算公式
  deleteMeasuringExpression: "/api/deleteMeasuringExpression", //删除计算公式
  listPhotosOfMeasure: "/api/listPhotosOfMeasure", //获取测量点相册照片信息
  addPhotoForMeasure: "/api/addPhotoForMeasure", //加入测量点照片
  removePhotoForMeasure: "/api/removePhotoForMeasure", //移除测量点照片
  setMeasureAlbumCover: "/api/setMeasureAlbumCover", //设置测量点相册封面
  getMeasureAlbumCover: "/api/getMeasureAlbumCover", //获取测量点相册封面
  getMeasuresInfoByParam: "/api/getMeasuresInfoByParam", //查询
  getMeasuresInfoByParam2: "/api/getMeasuresInfoByParam2", //查询
  getViewableMeasures: "/api/getViewableMeasures", //查询可视计量点
  shareMeasuresWithCompany: "/api/shareMeasuresWithCompany", //分享测量点
  unshareMeasuresWithCompany: "/api/unshareMeasuresWithCompany", //取消分享测量点
  listMeasuresOfMyCompanyShared: "/api/listMeasuresOfMyCompanyShared", //查询"我"分享测量点
  listMeasuresOfOtherCompanySharedWithMe:
    "/api/listMeasuresOfOtherCompanySharedWithMe", //查询分享给"我"的测量点
  getMeasuresParams: "/api/getMeasuresParams", //查询测量点参数
  getMeasureExpressions: "/api/getMeasureExpressions", //查询计算公式
  listPhotosOfMeasureByPack: "/api/listPhotosOfMeasureByPack", //根据计量点查相册
  getBottomNodeEnumClass: "/api/tmp/getBottomNodeEnumClass", //从容器内查询测量点2
  getEnergyViewRelationshipSetting: '/api/getEnergyViewRelationshipSetting',//从容器内查询测量点2

  getViewTreesInfoByCompanyId: '/api/custom/getViewTreesInfoByCompanyId',
  getMeasureInfoByViewTreeId: '/api/custom/getMeasureInfoByViewTreeId',
};

export default measure;
